<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">
                Routing in Progress
            </h4>
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body">
            Re-routing is still in progress, which may affect the order of stops in this trip.
            <br />
            Would you like to wait until routing is complete before sending the run sheet?
        </div>
        <div class="modal-footer">
            <md-button class="md-default dialog-button" @click.stop="$modal.hide">Wait</md-button>
            <md-button class="md-primary dialog-button" @click="handleSend">
                Send it Now
            </md-button>
        </div>
    </div>
</template>
<script>
/**
 * @description This component is shown to the user when the user wants to send a run sheet email but there are trips
 * that are not done yet.
 */
export default {
    name: 'ConfirmRunSheetModal',
    props: {
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    methods: {
        handleSend() {
            this.resolve('ok');
        }
    }
};
</script>
<style scoped lang="scss">
.modal-container {
    max-width: 500px;
    .modal-header {
    }
    .modal-body {
    }
}
</style>
